import EventList from './EventList.vue'
import CreateEventButton from './CreateEventButton.vue'
export default EventList
export { CreateEventButton }
